import React from 'react';

import Tooltip, {tooltipClasses} from "@mui/material/Tooltip";
import {styled} from "@mui/material/styles";

import {black500} from "assets/jss/main";

// Design system 2.0 tooltip (Feedback / Tooltip). Same API as the MUI
// Tooltip; the arrow follows the `placement` prop.
const CustomTooltip = styled(({className, ...props}) => (
    <Tooltip {...props} arrow classes={{popper: className}}/>
))({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: black500,
        color: '#fff',
        padding: '8px 12px',
        borderRadius: '8px',
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: 'normal',
        boxShadow: '0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)'
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: black500
    }
});

export default CustomTooltip;
